export const numberFormat = (value, includeCurrencySymbol = true) =>
  new Intl.NumberFormat("en", {
    style: includeCurrencySymbol ? "currency" : "decimal",
    currency: "USD",
  }).format(value);